import AUStates from './fr-CA/AU-states.json.js';
import CAStates from './fr-CA/CA-states.json.js';
import CNStates from './fr-CA/CN-states.json.js';
import CompanySize from './fr-CA/company-size.json.js';
import CompanyType from './fr-CA/company-type.json.js';
import countries from './fr-CA/countries.json.js';
import DEStates from './fr-CA/DE-states.json.js';
import HKStates from './fr-CA/HK-states.json.js';
import INStates from './fr-CA/IN-states.json.js';
import industry from './fr-CA/industry.json.js';
import interests from './fr-CA/interests.json.js';
import jobRole from './fr-CA/job-role.json.js';
import levelOfAWSUsage from './fr-CA/level-of-aws-usage.json.js';
import projectTimeline from './fr-CA/project-timeline.json.js';
import PTStates from './fr-CA/PT-states.json.js';
import USStates from './fr-CA/US-states.json.js';
import useCase from './fr-CA/use-case.json.js';
import languagePreference from './fr-CA/language-preference.json.js';
import Navatar from '../fr-CA/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
